import { Controller } from "@hotwired/stimulus";

/** postMessage type read by buy checkout AddFundsWalletController. */
export const CHECKOUT_ONRAMP_METHOD_SELECTED = "checkout_onramp_method_selected";

/** postMessage type read by buy checkout AddFundsWalletController: a payment is already pending. */
export const CHECKOUT_ONRAMP_PAYMENT_IN_PROGRESS = "checkout_onramp_payment_in_progress";

/**
 * Notifies the parent checkout frame when the shopper picks a fiat onramp method
 * (Meld/Stripe links with target="_blank"). Crypto deposit stays inside WaaS.
 */
export default class CheckoutDepositEmbedController extends Controller {
  static values = {
    onrampProvider: String,
    checkoutOrigin: String,
  };

  connect() {
    this.inIframe = this.#isEmbedded();
    if (this.inIframe) {
      document.documentElement.classList.add("embedded");
      document.body.classList.add("embedded");
    }
  }

  notifyParentOnExternalClick(event) {
    if (!this.inIframe || !this.checkoutOriginValue) return;

    const link = event.target.closest('a[target="_blank"]');
    if (!link) return;

    const href = link.getAttribute("href") || "";
    if (!href || href.startsWith("#")) return;

    globalThis.parent.postMessage(
      {
        type: CHECKOUT_ONRAMP_METHOD_SELECTED,
        href,
        provider: this.hasOnrampProviderValue ? this.onrampProviderValue : "",
      },
      this.checkoutOriginValue
    );
  }

  #isEmbedded() {
    try {
      return globalThis.self !== globalThis.top;
    } catch (_) {
      return true;
    }
  }
}
